import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Warm = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 32 32"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.6875" cy="13.717" r="9.14204" fill="#FB6434" stroke="#2B2F38" strokeWidth="1.4" />
      <circle cx="15.6875" cy="13.717" r="6.37043" fill="#F8B200" stroke="#2B2F38" strokeWidth="1.4" />
      <circle cx="15.6875" cy="13.717" r="3.42913" fill="#FFDB59" stroke="#2B2F38" strokeWidth="1.4" />
      <path
        d="M6.0625 28.1875L3.1875 13.125C10.8125 15.4375 22.875 15.6875 28.4375 13.125L25.875 26.125C20.875 28.625 14.625 29.5 6.0625 28.1875Z"
        fill="#F8B200"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 13.5L16.6875 25.217L28.0625 14.0625"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1875 28.0625L12.5625 21.467"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0625 21.2858L25.6875 25.875"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Warm
